import { useEffect, useState } from 'react';
import {
  getToken,
  setToken as setTokenManager,
  subscribe,
} from '../../util/tokenManager';

export const useToken = () => {
  const [token, setTokenInternal] = useState(() => {
    return getToken();
  });

  const setToken = (newToken) => {
    setTokenManager(newToken);
  };

  // Subscribe to token changes from the manager
  useEffect(() => {
    const unsubscribe = subscribe((newToken) => {
      setTokenInternal(newToken);
    });

    return unsubscribe;
  }, []);

  return [token, setToken];
};
